import { TickMarkIcon } from '@sketchnote/icons';
import { useRouter } from 'next/router';
import React, { useRef, useState } from 'react';
import { GroupTypeBase, OptionTypeBase } from 'react-select';
import { useBoardStore } from 'src/features/boards';
import { useTableStore } from 'src/features/list/store';
import { Task } from 'src/features/tasks/types/tasks';
import useOnClickOutside from 'use-onclickoutside';
import { v4 as uuid } from 'uuid';

const TableColor = {
  '#fbb6ce': '#EC7DD5',
  '#d6bcfa': '#18B4E6',
  '#81e6d9': '#81e6d9',
  '#86E495': '#7AA00D',
  '#9BADEE': '#211650',
  '#fbd38d': '#FD9740',
  '#FFE98F': '#FFE98F',
  '#FBB1A7': '#FBB1A7',
};

type OptionType = OptionTypeBase & { label: string; value: string };
type GroupType = GroupTypeBase<OptionType>;

const randomColor = [
  '#fbb6ce',
  '#d6bcfa',
  '#9BADEE',
  '#81e6d9',
  '#86E495',
  '#FFE98F',
  '#fbd38d',
  '#FBB1A7',
];
export const SelectFieldCell = ({
  task,
  fieldId,
  data,
  api,
}: {
  task: Partial<Task>;
  fieldId: string;
  data: any;
  api: any;
}): JSX.Element => {
  const [inputLabel, setInputLabel] = useState<string>('');
  const myRef = useRef(null);
  const { isReadOnly } = useTableStore();

  const fetchSelectables = useBoardStore((s) => s.actions.fetchSelectables);
  const { selectables } = useBoardStore((s) => ({ selectables: s.selectables }));
  const onUpdateCustomFieldData = useTableStore((s) => s.onUpdateCustomFieldData);

  const router = useRouter();

  const handleAddLabel = async () => {
    const updatedLabel = [
      {
        color: randomColor[Math.floor(Math.random() * randomColor.length)],
        id: uuid(),
        label: inputLabel,
        value: inputLabel,
      },
    ];
    setInputLabel('');
    await onUpdateCustomFieldData(task, fieldId, updatedLabel);
    // TODO this needs to happen after new label creation has responded
    fetchSelectables({ id: router?.query?.view as string });
    api.stopEditing();
  };

  const handleChangeLabel = async (value) => {
    await onUpdateCustomFieldData(task, fieldId, [value]);
    fetchSelectables({ id: router?.query?.view as string });
    api.stopEditing();
  };

  useOnClickOutside(myRef, () => {
    api.stopEditing();
  });

  return (
    <div className="w-275 p-16 rounded-lg z-100 bg-white" ref={myRef}>
      <input
        value={inputLabel}
        className="bg-gray-100 p-10 text-sm w-full"
        placeholder="Select a label or create one"
        onChange={(e) => setInputLabel(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && inputLabel.trim() !== '') {
            handleAddLabel();
          }
        }}
      />

      <div className="max-h-384 overflow-y-auto mt-16">
        {inputLabel.trim() === '' ? (
          selectables[fieldId] && selectables[fieldId].length > 0 ? (
            selectables[fieldId].map((labelOption) => (
              <div
                style={{ lineHeight: '10px' }}
                key={`${labelOption.id}`}
                onClick={handleChangeLabel.bind(null, labelOption)}
                className=" hover:bg-gray-100 w-full py-4 font-semibold text-white rounded-sm px-6"
              >
                <button className="flex justify-between w-full ">
                  <span
                    className="inline-block px-6 rounded-sm text-xs py-4"
                    style={{ backgroundColor: TableColor[labelOption.color] }}
                  >
                    {labelOption.label}
                  </span>

                  {labelOption.isChecked && <TickMarkIcon className="mt-4 text-blue-600" />}
                </button>
              </div>
            ))
          ) : (
            <></>
          )
        ) : (
          <div
            onClick={handleAddLabel}
            className="cursor-pointer hover:text-gray-700 p-8 text-sm text-gray-600"
          >
            Create label {inputLabel}
          </div>
        )}
      </div>
    </div>
  );
};
